import { ProductCardSkeleton } from '~/shared/components/product-card/product-card-skeleton/product-card-skeleton.component';
import styles from './loading-carousel.module.css';
import { Skeleton } from '~/shared/components/skeleton/skeleton.component';
import { memo } from 'react';

const ProductCarouselSkeleton = memo(() => {
    return (
        <div className={styles.root}>
            <div className={styles.headerWrapper}>
                <Skeleton width="280px" height="20px" />
            </div>
            <ul className={styles.sliderRoot}>
                {[...Array(8).keys()].map((index) => (
                    <li key={index} className={styles.sliderItem}>
                        <ProductCardSkeleton />
                    </li>
                ))}
            </ul>
        </div>
    );
});

ProductCarouselSkeleton.displayName = 'ProductCarouselSkeleton';

export default ProductCarouselSkeleton;
